import { render, staticRenderFns } from "./OldResultsPage2021.vue?vue&type=template&id=40ce89e5"
import script from "./OldResultsPage2021.vue?vue&type=script&lang=js"
export * from "./OldResultsPage2021.vue?vue&type=script&lang=js"
import style0 from "./OldResultsPage2021.vue?vue&type=style&index=0&id=40ce89e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports